/**
 * @param {object[]} templates
 * @returns {object[]}
 */
export function buildWorkflowTimeline(templates) {
  const timeline = []
  for (const template of templates) {
    timeline.push({ kind: 'action', ...template, defaultExpanded: false })
    if (template.stepNarration) {
      timeline.push({ kind: 'narration', content: template.stepNarration })
    }
  }
  return timeline
}

/** @param {object[]} timeline */
export function countWorkflowActionSteps(timeline) {
  return timeline.filter((entry) => entry.kind !== 'narration').length
}
